export var radius_2 = '2px';
export var radius_8 = '8px';
export var radius_24 = '24px';
export var radius_40 = '40px';
export var borderLinearRadius = function borderLinearRadius(width, linearColor) {
  return "\n  border: ".concat(width, "px solid;\n  border-image: ").concat(linearColor, " 1;\n  clip-path: inset(0 round ").concat(width, "px);\n");
};